<template>
    <v-popover offset="0" :open="isOpen" trigger="click" :autoHide="true" v-on:auto-hide="close" placement="left">

        <div class="tooltip-target" @click="open" data-testid="client-banner-auth">
            <button class="btn btn-sm btn-danger" data-testid="client-auth-none" v-tooltip="'Vytvořit PIN klienta'" v-if="client.has_pin === false">nemá PIN</button>
            <template v-else="">
                <button class="btn btn-sm btn-success" data-testid="client-auth-verified" v-tooltip="'Klient ověřen'" v-if="clientAuthVerifyDone === true"><i class="fa fa-check-circle"></i> ověřen</button>
                <button class="btn btn-sm btn-outline-success" data-testid="client-auth-verify" v-tooltip="'Ověřit klienta'" v-else="">ověřit</button>
            </template>
        </div>
        <template slot="popover">
            <div class="container tooltip_container tooltip_1_col p-0">
                <template v-if="client.has_pin === false || changePass === true">
                    <div class="row tooltip_header m-0">
                        <template v-if="changePass === false">
                            <div class="col-sm-12">Vytvořit PIN klienta</div>
                        </template>
                        <template v-else="">
                            <div class="col-sm-1"><button class="btn btn-sm btn-outline-success" v-tooltip="'Zrušit změnu'" @click="edit"><i class="fa fa-close"></i></button></div>
                            <div class="col-sm-10">Změnit PIN klienta</div>
                            <div class="col-sm-1"></div>
                        </template>
                    </div>
                    <form @submit.prevent="createUpdateClientAuth">
                        <div class="row tooltip_body m-0">
                            <!-- fake fields are a workaround for chrome autofill getting the wrong fields -->
                            <input style="display:none" type="text" name="clientAuthPass"/>

                            <div class="form-group col-sm-12">
                                <label for="personalid">PIN:</label>
                                <input v-model="clientAuthCreateForm.plain_password" autocomplete="off" type="text" class="form-control" aria-describedby="clientAuthPassHelp" id="clientAuthPass" name="clientAuthPass" data-testid="client-auth-pin-input">
                                <span class="text-danger">{{ clientAuthCreateError.plainpassword ?  clientAuthCreateError.plainpassword.message : '' }}</span>
                            </div>
                            <!--<div class="form-group col-sm-12">
                                <label for="personalid">kontrola PINu:</label>
                                <input v-model="clientAuthCreateForm.plain_password_2" type="text" class="form-control" aria-describedby="personalidHelp" id="personalid">
                            </div>-->
                            <div class="form-group col-sm-12">
                                <label for="personalid">Nápověda k PINu:</label>
                                <input v-model="clientAuthCreateForm.help" type="text" autocomplete="off" class="form-control" aria-describedby="personalidHelp" id="personalid" data-testid="client-auth-help-input">
                                <span class="text-danger">{{ clientAuthCreateError.help ?  clientAuthCreateError.help.message : '' }}</span>
                            </div>
                            <div class="form-group col-sm-12 text-center">
                                <template v-if="changePass === false">
                                    <button type="submit" class="btn btn-primary" data-testid="client-auth-save">Uložit PIN</button>
                                </template>
                                <template v-else="">
                                    <button type="submit" class="btn btn-primary" data-testid="client-auth-save">Změnit PIN</button>
                                </template>
                            </div>
                        </div>
                    </form>
                </template>
                <template v-else="">
                    <div class="row tooltip_header m-0">
                        <div class="col-sm-1"><button class="btn btn-sm btn-outline-success" data-testid="client-auth-change" v-tooltip="'Změnit PIN'" @click="edit"><i class="fa fa-pencil"></i></button></div>
                        <div class="col-sm-10">Ověřit PIN klienta</div>
                        <div class="col-sm-1"></div>
                    </div>
                    <form @submit.prevent="verifyClientAuth">
                        <div class="row tooltip_body m-0">
                            <div class="form-group col-sm-12">
                                <label for="personalid">PIN:</label>
                                <input v-model="clientAuthVerify.plain_password" type="text" autocomplete="off" class="form-control" aria-describedby="personalidHelp" id="personalid" data-testid="client-auth-verify-input">
                                <span class="text-danger" data-testid="client-auth-verify-error">{{ clientAuthVerifyError ?  clientAuthVerifyError : '' }}</span>
                            </div>
                            <div class="form-group col-sm-12">
                                <small>Nápověda: </small>
                                <span data-testid="client-auth-help">{{ client.client_auth.help }}</span>
                            </div>
                            <div class="form-group col-sm-12 text-center">
                                <template>
                                    <button type="submit" class="btn btn-primary" data-testid="client-auth-verify-submit">Ověřit PIN</button>
                                </template>
                            </div>
                        </div>
                    </form>
                </template>
            </div>
        </template>
    </v-popover>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        isOpen: false,
        changePass: false,
        clientAuthCreateError: false,
        clientAuthCreatePending: false,
        clientAuthCreateDone: false,
        isVerified: false,
        clientAuthCreateForm: {
          plain_password: '',
          help: ''
        },
        clientAuthVerifyError: false,
        clientAuthVerifyPending: false,
        clientAuthVerifyDone: false,
        clientAuthVerify: {
          plain_password: ''
        }
      }
    },
    mixins: [apiMixin],
    props: ['client', 'clientHeader'],
    methods: {
      open () {
        this.isOpen = true
        this.changePass = false
      },
      close () {
        this.isOpen = false
      },
      createUpdateClientAuth () {
        if (this.changePass === true) {
          this.updateClientAuth()
        } else {
          this.createClientAuth()
        }
      },
      createClientAuth () {
        this.clientAuthCreatePending = true
        this.$http.post('client/' + this.client.id + '/password', this.clientAuthCreateForm, {emulateJSON: true}).then(response => {
          this.clientAuthCreatePending = false
          this.clientAuthCreateDone = true
        }).catch(error => {
          this.clientAuthCreateError = error.response.data.errors
          console.log(this.clientAuthCreateError)
          this.clientAuthCreatePending = false
        })
      },
      updateClientAuth () {
        this.clientAuthCreatePending = true
        this.$http.put('client/' + this.client.id + '/password', this.clientAuthCreateForm, {emulateJSON: true}).then(response => {
          this.clientAuthCreatePending = false
          this.clientAuthCreateDone = true
        }).catch(error => {
          this.clientAuthCreateError = error.response.data.errors
          console.log(this.clientAuthCreateError)
          this.clientAuthCreatePending = false
        })
      },
      verifyClientAuth () {
        this.clientAuthVerifyPending = true
        this.$http.post('client/' + this.client.id + '/verify', this.clientAuthVerify, {emulateJSON: true}).then(response => {
          this.clientAuthVerifyPending = false
          this.clientAuthVerifyDone = true
        }).catch(error => {
          this.clientAuthVerifyError = error.response.data.error
          this.clientAuthVerifyPending = false
        })
      },
      edit () {
        this.changePass = !this.changePass
      },
      view () {
        this.editMode = false
      }
    },
    watch: {
      isOpen (val) {
        if (val === true) {
          this.clientAuthVerifyError = false
          this.clientAuthVerifyDone = false
          this.clientAuthCreateForm = {
            plain_password: '',
            help: ''
          }
          this.clientAuthVerify = {
            plain_password: ''
          }
        } else {
          //
        }
      },
      clientAuthCreateDone (val) {
        if (val === true) {
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.clientAuthCreateDone = false
          this.changePass = false
          this.close()
        }
      },
      clientAuthVerifyDone (val) {
        if (val === true) {
          this.clientAuthVerify = {
            plain_password: ''
          }
          this.close()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .input-group.input-group-unstyled input.form-control {
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }
    .input-group-unstyled .input-group-addon {
        border-radius: 4px;
        border: 0px;
        background-color: transparent;
    }
    .row_description {
    }
    .row_description > td {
        padding-bottom: 1px;
        border: none;
        font-size: smaller;
    }
    .row_data {
    }
    .row_data > td {
        padding-top: 0px;
        font-weight: bold;
        font-size: large;
        border: none;
    }

    .width_fix {
        width: 100%;
    }
    .label_like {
        max-width: 100%;
        /*font-weight: bold;*/
    }
    .main_attribute {
        max-width: 100%;
        font-size: x-large;
        font-weight: bold;
    }

    .custom_panel_heading {
        border-bottom: none;
        padding-bottom: 0;
        background-color: #b5e3cf;
    }

    .custom_panel_heading .nav-tabs {
        border-bottom: none;
    }

    .custom_panel_heading .nav-tabs > li > a {
        background-color: #fff;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(odd) {
        margin-right: 0;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(even) {
        margin-left: 0;
    }

    /*modal insurance*/

    tr.valid_line {
        font-weight: bold;
    }

    .modal_default {
        overflow: visible !important;
    }

    table.table td {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/Client/components/ClientAuth.vue?acc44132